import React from "react";
import { useNavigate } from "react-router-dom";

const Button = ({
  text,
  onClick,
  className = "",
  variant = "primary",
  size = "md",
  link,
  disabled = false,
}) => {
  const navigate = useNavigate();

  const baseStyles =
    "inline-flex items-center justify-center font-semibold rounded-pill transition-all duration-300 ease-out focus:outline-none focus:ring-2 focus:ring-primary-200 hover:-translate-y-0.5 active:translate-y-0";

  const variants = {
    primary:
      "bg-primary text-white shadow-cta hover:bg-primary-600",
    secondary:
      "bg-secondary text-white shadow-soft hover:bg-ink",
    outline:
      "bg-transparent text-primary border border-primary hover:bg-primary hover:text-white",
    whitish:
      "bg-white text-primary shadow-soft hover:bg-primary-50",
    ghost:
      "bg-transparent text-ink hover:bg-primary-50",
    disabled:
      "bg-line text-muted cursor-not-allowed hover:translate-y-0",
  };

  const sizes = {
    sm: "px-5 py-2 text-sm",
    md: "px-7 py-3 text-base",
    lg: "px-9 py-4 text-lg",
  };

  const handleClick = () => {
    if (disabled) return;
    if (link) navigate(link);
    if (onClick) onClick();
  };

  return (
    <button
      onClick={handleClick}
      disabled={disabled}
      className={`${baseStyles} ${
        disabled ? variants["disabled"] : variants[variant]
      } ${sizes[size]} ${className}`}
    >
      <span>{text}</span>
    </button>
  );
};

export default Button;
